import {Component, computed, input} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {
  Campaign,
  CampaignUserStatus,
  getCampaignRemainingRewards,
  getCampaignTotalRewards,
  locationDisplayFunction
} from '../../../services/model';
import {
  CampaignTimeConditionsDetailsComponent
} from './campaign-time-conditions-details/campaign-time-conditions-details.component';
import {LoyaltyNumberPipe} from '../../pipes/loyalty-number.pipe';

@Component({
  selector: 'app-campaign-card-promo-details',
  standalone: true,
  templateUrl: './campaign-card-promo-details.component.html',
  styleUrl: './campaign-card-promo-details.component.scss',
  imports: [CommonModule, NgOptimizedImage, TranslocoDirective, CampaignTimeConditionsDetailsComponent, LoyaltyNumberPipe]
})
export class CampaignCardPromoDetailsComponent {

  campaign = input.required<Campaign>();
  campaignUserStatus = input<CampaignUserStatus>(CampaignUserStatus.ACTIVE);
  lightFont = input(false);
  highContrast = input(false);
  displayLocation = input(true);

  totalRewards = computed<number | undefined>(() => getCampaignTotalRewards(this.campaign()));
  remainingRewards = computed<number | undefined>(() => getCampaignRemainingRewards(this.campaign()));

  location = computed<string | undefined>(() => {
    const locationsGroup = this.campaign().locationsGroup;
    if (locationsGroup?.locations && locationsGroup?.locations.length > 0) {
      return locationDisplayFunction(locationsGroup.locations[0])
    }
    return undefined;
  });

  protected readonly CampaignUserStatus = CampaignUserStatus;
}
